import { t, useLocale } from '../localization/adminText';
import { BlockStack, Card, Checkbox, Text } from './admin-ui';

export default function CodFulfillmentHistorySettings({ settings, update, disabled = false }) {
  useLocale();
  return <Card>
    <BlockStack gap="300">
      <Text as="h2" variant="headingMd">{t('Fulfillment history reminders')}</Text>
      <Text as="p">{t('Show delivery rates and refusal history using this store\'s imported results and reviewed shared records.')}</Text>
      <Checkbox
        label={t('Enable fulfillment history checks')}
        checked={settings.fulfillment_history_enabled === true || settings.fulfillment_history_enabled === 1}
        onChange={(checked) => update('fulfillment_history_enabled', checked)}
        disabled={disabled}
        helpText={t('Enable and save to start history checks. Turning this off stops these checks; importing results remains available.')}
      />
      <Text as="p" tone="subdued">{t('Delivery history is for review only and does not automatically block orders.')}</Text>
    </BlockStack>
  </Card>;
}
